<template>
  <div>
    <Navigation />
    <section class="section__container top__container blog__details blogs">
      <h1 class="about__title ">Qui sommes-nous ?</h1>
      <p>Nous sommes une petite équipe qui fait de grandes choses.</p>
      <p>
        Servicesms.sn est un service en ligne de premier plan au Sénégal, offrant des services d'envoi de SMS.
        Il s'est imposé comme un leader incontesté dans le domaine de la communication mobile. Spécialisé dans
        l'envoi de SMS en masse pour les particuliers et les professionnels, notre entreprise est le chef de file
        des solutions de messagerie mobile. Nous sommes là pour accompagner les associations, les amicales et les
        entreprises dans leur quête de performance, en leur offrant des solutions de communication puissantes et innovantes. 
        Notre objectif est de vous fournir en permanence les meilleures technologies pour vos campagnes SMS et vos opérations
        de marketing mobile.
      </p>

        <h2 class="about__title center">Notre mission</h2>
        
        Nous sommes constamment engagés dans l'innovation et notre objectif est de créer des solutions simples et sans tracas 
        pour nos clients. Nous voulons leur permettre de se concentrer sur l'essentiel : faire croître leur entreprise 
        et atteindre leurs objectifs et leur succès. Nous sommes guidés par des valeurs fondamentales telles que la priorité
        accordée à l'utilisateur, la transformation de l'expérience client grâce à l'utilisation de canaux de communication 
        plus profonds, pertinents, personnalisés et significatifs.

      <vue-modaltor :visible="open" @hide="hideModal">
        <template slot="close-icon">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            width="20"
            height="20"
            xml:space="preserve"
          >
            <path
              class="st0"
              fill="#0074D9"
              d="M8.7,7.6c-0.4-0.4-1-0.4-1.4,0C6.9,8,6.9,8.6,7.3,9l11,11l-11,11c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 l11-11l11,11c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-11-11L32,9c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-11,11L8.7,7.6z"
            />
          </svg>
        </template>
        <p class="center__text">
          Nous valorisons les amicales, les associations et les entreprises, car elles sont à l'origine de nos idées<br/>
          et de notre innovation, et jouent un rôle essentiel dans notre croissance continue.
        </p>
        <p class="center__text">
          Notre valeur fondamentale envers nos clients et entre nous est de gagner leur confiance chaque jour.<br/>
          Nous devons être dignes de confiance, car l'opportunité de servir nos clients est plus importante<br/> 
          que chacun d'entre nous individuellement.
        </p>
      </vue-modaltor>
      <div class="engagement">
        <h2 class="about__title center">Nos engagements</h2>
        <div class="grid__engagement">
          <div>
            <h3>Plateforme efficace :</h3>
            <ul>
              <li>Disponibilité 24h/24 et 7j/7</li>
              <li>Facile à utiliser</li>
              <li>Solutions diversifiées, nombreuses</li>
            </ul>
          </div>

          <div>
            <h3>Équipe hors pair, unie :</h3>
            <ul>
              <li>Un Account Manager dédié</li>
              <li>Aide tout temps, campagne</li>
              <li>Aide sur mesure, personnalisée</li>
            </ul>
          </div>
          <div>
            <h3>Solution sûre, garantie :</h3>
            <ul>
              <li>Plateforme SaaS sûre</li>
              <li>Respect PDCP, conforme strict</li>
              <li>Données bien protégées</li>
              
            </ul>
          </div>
        </div>
      </div>
      <div class="team">
        <h2 class="about__title center__text">Faites la rencontre de notre équipe en mode 100% à distance</h2>
        <p class="center__text">
          Notre équipe est constituée de professionnels hautement qualifiés. Nous sommes des individus passionnés
          et déterminés, dotés d'un esprit d'équipe solide. Ce que nous créons a une valeur immense pour les entreprises
          de toutes tailles et tous secteurs. Notre équipe produit est innovante, créative et audacieuse. En tant que
          créateurs et contributeurs, nous collaborons étroitement avec chaque département pour guider notre entreprise
          vers l'avenir.
        </p>

        <div class="profiles">
          <div class="profile__president">
            <img
              src="/../images/profile/sylla-sg.png"
              alt=""
              class="profile__image"
            />
            <p to="" class="profile__name" @mouseover="open = true">
              SYLLA Harouna
            </p>
            <p class="profile__title">Fondateur & CEO – SERVICES-SMS</p>
                
          </div>
          <div class="other__profile">
          
            <div class="two__grid">
              <div class="profile">
                <img
                  src="/../images/profile/khady_rc.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >GUEYE Moctar Khady</router-link
                >
                <p class="profile__title">Directrice commerciale</p>
                 
              </div>

              <div class="profile">
                <img
                  src="/../images/profile/Dieynaba-ka.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name">KA Dieynaba </router-link>
                <p class="profile__title">Responsable Commerciale</p>
                
              </div>
            </div>
          </div>

          <div class="other__profile">
           
            <div class="three__grid">
              <div class="profile">
                <img
                  src="/../images/profile/abdoulaye_Resp_com.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >BA Abdoulaye  </router-link
                >
                <p class="profile__title">Chargé de Marketing et Communication</p>
               
              </div>

              <div class="profile">
                <img
                  src="/../images/profile/madame-sy.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  > SALL Fatimata</router-link
                >
                <p class="profile__title">Directrice juridique</p>
              
              </div>

               <div class="profile">
                <img
                  src="/../images/profile/Aissata-Oumar-SOW.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >SOW Aissata Oumar</router-link
                >
                <p class="profile__title">Responsable Marketing</p>
              
              </div>
            </div>
          </div>
          <div class="other__profile">
          
          <div class="profile__president spacer-2">
            

          </div>

      <div class="three__grid">
         <div class="profile">

            <img
              src="/../images/profile/service-client.png"
              alt=""
              class="profile__image"
            />
            <router-link to="" class="profile__name"> KANE  Aïssatou</router-link>
            <p class="profile__title">Chargée de Clientéle</p>
  
         </div>
           <div class="profile">
                <img
                  src="/../images/profile/Keita-Penda-Soukho.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >KEITA Penda Soukho </router-link
                >
                <p class="profile__title">Assistante Administrative</p>
                
              </div>

               <div class="profile">
                <img
                  src="/../images/profile/respon-part.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >BA Amadou Baba </router-link
                >
                <p class="profile__title">Responsable Partenariats</p>
                
              </div>
              </div>


            </div>  
          <div class="other__profile">
          
            <div class="three__grid">
              <div class="profile">
                <img
                  src="/../images/profile/ba-h-2.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >BA  Hamady <br />
                   </router-link
                >
                <p class="profile__title">Co-fondateur Directeur Technique</p>
                
              </div>

              <div class="profile">
                <img
                  src="/../images/profile/ousmane-sy.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >SY Ousmane </router-link
                >
                <p class="profile__title">Business Developer</p>
                
              </div>
               <div class="profile">
                <img
                  src="/../images/profile/drame-baboucar.png"
                  alt=""
                  class="profile__image"
                />
                <router-link to="" class="profile__name"
                  >DRAMMEH Baboucarr </router-link
                >
                <p class="profile__title">Développeur</p>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import Navigation from "./Navigation";
import Footer from "./Footer";
import VueModalTor from "vue-modaltor";
Vue.use(VueModalTor);
export default {
  data() {
    return {
      open: false,
    };
  },
  components: {
    Navigation,
    Footer,
  },
  methods: {
    hideModal() {
      this.open = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.about__title {
  color: $color-tertiary;
}
.profile__president,
.other__profile {
  text-align: center;
}
.profile__image {
  display: block;
  margin: 0 auto;
  transition: transform .2s;

  &:hover{
    transform: scale(1.1); 
  }
}
.catogery__header {
  border-bottom: 2px solid $color-tertiary;
  margin-top: 2rem;
}

.profile__name {
  display: block;
  text-decoration: none;
  font-weight: bold;
  color: $color-tertiary;
  font-size: 1.2rem;
  cursor: pointer;
}

.profile__title {
  font-weight: bolder;
  color: #7a7a7a;
}

@media (min-width: 64rem) {
  .grid__engagement {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
  }
  .top__container{
  margin-top:10rem;
 }
  .catogery__header {
    width: 45%;
    margin: 0 auto;
  }
  .two__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid: 2rem;
    margin-top: 3rem;
  }

   .three__grid {
    display: grid;
    grid-template-columns:1fr 1fr 1fr;
    grid: 2rem;
    margin-top: 3rem;
  }
}
</style>
